import { addDays, diffDays } from './dates.js';
/** Avanço = Σ(peso × %) / Σ pesos. Por construção nunca passa de 100%. */
export function weighted(items, f) {
    let w = 0, s = 0;
    for (const i of items) {
        if (!(i.weight > 0))
            continue;
        w += i.weight;
        s += i.weight * Math.min(100, Math.max(0, f(i)));
    }
    return w ? s / w : 0;
}
export function groupProgress(items, key, date) {
    const groups = {};
    for (const i of items)
        (groups[key(i)] ??= []).push(i);
    const out = {};
    for (const [k, arr] of Object.entries(groups))
        out[k] = { weight: arr.reduce((s, i) => s + i.weight, 0), real: weighted(arr, i => i.percent), planned: weighted(arr, i => i.planned(date)), count: arr.length };
    return out;
}
/** Rampa linear entre início e término (inclusive). */
export function linearPlanned(start, finish, date) {
    if (!start || !finish)
        return 0;
    if (date < start)
        return 0;
    if (date >= finish)
        return 100;
    return 100 * (diffDays(start, date) + 1) / Math.max(1, diffDays(start, finish) + 1);
}
/** Medição por quantidade executada. */
export const quantityPercent = (done, total) => total > 0 ? Math.min(100, Math.max(0, 100 * done / total)) : 0;
/** Marcos ponderados: soma dos pesos dos marcos internos atingidos. */
export function weightedMilestones(steps) {
    const t = steps.reduce((s, x) => s + x.weight, 0);
    return t ? 100 * steps.filter(x => x.achieved).reduce((s, x) => s + x.weight, 0) / t : 0;
}
/** Previsão de conclusão por regressão linear dos pontos (medições aprovadas + atual). */
export function forecastCompletion(points, today) {
    const P = points.filter((p, i, a) => a.findIndex(x => x.date === p.date) === i);
    const cur = P.find(p => p.date === today) ?? P[P.length - 1];
    if (P.length < 2 || !cur)
        return { rate: 0, date: null, basis: 'Dados insuficientes: são necessárias ao menos uma medição aprovada e o avanço atual.' };
    const xs = P.map(p => diffDays(P[0].date, p.date)), ys = P.map(p => p.real);
    const n = P.length, mx = xs.reduce((a, b) => a + b, 0) / n, my = ys.reduce((a, b) => a + b, 0) / n;
    let num = 0, den = 0;
    for (let i = 0; i < n; i++) {
        num += (xs[i] - mx) * (ys[i] - my);
        den += (xs[i] - mx) ** 2;
    }
    const rate = den ? num / den : 0;
    if (rate <= 0.0001)
        return { rate: 0, date: null, basis: 'Sem avanço no período recente: não é possível projetar a conclusão.' };
    return { rate, date: addDays(today, Math.ceil((100 - cur.real) / rate)), basis: `Ritmo recente de ${(rate * 30).toFixed(1).replace('.', ',')} p.p. por mês (${n} pontos).` };
}
/** Compara o desvio atual com o da última medição aprovada (tolerância de 0,5 p.p.). */
export function trend(lastApproved, current) {
    if (!lastApproved)
        return { label: 'Sem histórico', delta: null };
    const delta = (current.real - current.planned) - (lastApproved.real - lastApproved.planned);
    return { label: delta > 0.5 ? 'Recuperação' : delta < -0.5 ? 'Agravamento' : 'Estável', delta };
}
//# sourceMappingURL=progress.js.map